import { createActionGroup, props } from '@ngrx/store';
import { User } from '../models/user';
import { Policy } from '../models/policy';

export const AuthActions = createActionGroup({
    source: 'Auth',
    events: {
        'Init Login Success': props,
        'Login': props,
        'Login Process': props,
        'Login Fail': props<{ error: any }>(),
        'Login Sucess': props<{ user: User }>(),

        'Init Login In Progress': props,
        'Login Progress': props<{ user: User }>(),
        'Login Progress No Auth': props,

        'Init Logout Success': props,
        'Logout Success': props,

        'Logout': props,

        'Destroy': props
    }
})

export const AuthApiActions = createActionGroup({
    source: 'Auth API',
    events: {
        'Load User Policies' : props,
        'Load User Policies Success': props<{ policies: Policy[] }>()
    }
})